import { useContext } from 'react';
import { useAlertContext } from '../context/AlertContext';

export const useAlert = () => {
	const { showAlert, dismissAlert, clearAlerts, alerts } = useAlertContext();

	return {
		showAlert,
		dismissAlert,
		clearAlerts,
		alerts,
	};
};
